import React, { useState } from "react";
import { siteContent } from "../content";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [toast, setToast] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Contact form submitted", form);
    setToast("Thank you! We will get back to you shortly.");
    setForm({ name: "", email: "", message: "" });
    setTimeout(() => setToast(""), 3200);
  };

  return (
    <div className="relative">
      <form
        onSubmit={handleSubmit}
        className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 shadow-2xl space-y-4"
      >
        <div>
          <label className="block text-sm font-semibold text-white mb-2">
            Name
          </label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            className="w-full rounded-xl bg-black/40 border border-white/10 px-4 py-3 text-white focus:border-amber-300 outline-none"
            placeholder="Your name"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-white mb-2">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            className="w-full rounded-xl bg-black/40 border border-white/10 px-4 py-3 text-white focus:border-amber-300 outline-none"
            placeholder="you@example.com"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-white mb-2">
            Message
          </label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            required
            rows={4}
            className="w-full rounded-xl bg-black/40 border border-white/10 px-4 py-3 text-white focus:border-amber-300 outline-none resize-none"
            placeholder="Tell us about your concert, show, or booking needs"
          />
        </div>

        <button
          type="submit"
          className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-amber-400 text-black font-semibold px-4 py-3 shadow-lg hover:-translate-y-0.5 hover:shadow-amber-400/40 transition"
        >
          Send Message
        </button>

        <div className="text-center text-sm text-gray-300">
          Prefer quick contact?{" "}
          <a
            href={siteContent.contact.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-amber-200 font-semibold underline-offset-4 hover:text-amber-100"
          >
            WhatsApp us at {siteContent.contact.whatsapp}
          </a>
        </div>
      </form>

      {toast && (
        <div className="pointer-events-none absolute inset-x-0 -bottom-10 flex justify-center">
          <div className="rounded-full bg-amber-400 text-black font-semibold px-4 py-2 shadow-lg animate-pulse">
            {toast}
          </div>
        </div>
      )}
    </div>
  );
}
